/**
 * This file was auto-generated by openapi-typescript.
 * Do not make direct changes to the file.
 *
 * API Title: Partner
 * API Version: 1.1.11
 */
export var ExecutionResultEnum;
(function (ExecutionResultEnum) {
    ExecutionResultEnum["SUCCESS"] = "SUCCESS";
    ExecutionResultEnum["FAILURE"] = "FAILURE";
    ExecutionResultEnum["VALIDATION_ERROR"] = "VALIDATION_ERROR";
    ExecutionResultEnum["CREATED"] = "CREATED";
    ExecutionResultEnum["UPDATED"] = "UPDATED";
    ExecutionResultEnum["DELETED"] = "DELETED";
})(ExecutionResultEnum || (ExecutionResultEnum = {}));
export var PartyKeyTypeEnum;
(function (PartyKeyTypeEnum) {
    PartyKeyTypeEnum["HOST"] = "HOST";
    PartyKeyTypeEnum["DITRO"] = "DITRO";
})(PartyKeyTypeEnum || (PartyKeyTypeEnum = {}));
export var PartyRoleEnum;
(function (PartyRoleEnum) {
    PartyRoleEnum["INT"] = "INT";
    PartyRoleEnum["VNR"] = "VNR";
    PartyRoleEnum["VEP"] = "VEP";
    PartyRoleEnum["BEZ"] = "BEZ";
    PartyRoleEnum["GES"] = "GES";
    PartyRoleEnum["ZBE"] = "ZBE";
    PartyRoleEnum["BEV"] = "BEV";
    PartyRoleEnum["VGL"] = "VGL";
    PartyRoleEnum["PZL"] = "PZL";
    PartyRoleEnum["BET"] = "BET";
    PartyRoleEnum["GDR"] = "GDR";
    PartyRoleEnum["SBE"] = "SBE";
    PartyRoleEnum["HBM"] = "HBM";
    PartyRoleEnum["MAK"] = "MAK";
    PartyRoleEnum["AGE"] = "AGE";
    PartyRoleEnum["AGR"] = "AGR";
    PartyRoleEnum["AGG"] = "AGG";
    PartyRoleEnum["SVE"] = "SVE";
    PartyRoleEnum["RVE"] = "RVE";
    PartyRoleEnum["MV"] = "MV";
    PartyRoleEnum["EDS"] = "EDS";
    PartyRoleEnum["EDB"] = "EDB";
    PartyRoleEnum["ZE"] = "ZE";
    PartyRoleEnum["SSB"] = "SSB";
    PartyRoleEnum["ZMA"] = "ZMA";
})(PartyRoleEnum || (PartyRoleEnum = {}));
export var FederalStateATEnum;
(function (FederalStateATEnum) {
    FederalStateATEnum["WIEN"] = "W";
    FederalStateATEnum["KAERNTEN"] = "K";
    FederalStateATEnum["BURGENLAND"] = "B";
    FederalStateATEnum["NIEDEROESTERREICH"] = "N";
    FederalStateATEnum["OBEROESTERREICH"] = "O";
    FederalStateATEnum["SALZBURG"] = "S";
    FederalStateATEnum["STEIERMARK"] = "ST";
    FederalStateATEnum["TIROL"] = "T";
    FederalStateATEnum["V"] = "V";
})(FederalStateATEnum || (FederalStateATEnum = {}));
export var SalutationEnum;
(function (SalutationEnum) {
    SalutationEnum["HERR"] = "H";
    SalutationEnum["FRAU"] = "F";
    SalutationEnum["AN"] = "A";
})(SalutationEnum || (SalutationEnum = {}));
export var CivilStatusEnum;
(function (CivilStatusEnum) {
    CivilStatusEnum["LED"] = "LED";
    CivilStatusEnum["VRH"] = "VRH";
    CivilStatusEnum["GSD"] = "GSD";
    CivilStatusEnum["VWT"] = "VWT";
    CivilStatusEnum["LGT"] = "LGT";
    CivilStatusEnum["EPL"] = "EPL";
    CivilStatusEnum["AEP"] = "AEP";
    CivilStatusEnum["HEP"] = "HEP";
    CivilStatusEnum["UNB"] = "UNB";
    CivilStatusEnum["GEL"] = "GEL";
})(CivilStatusEnum || (CivilStatusEnum = {}));
export var EmploymentEnum;
(function (EmploymentEnum) {
    EmploymentEnum["UNB"] = "UNB";
    EmploymentEnum["FRB"] = "FRB";
    EmploymentEnum["GU"] = "GU";
    EmploymentEnum["OED"] = "OED";
    EmploymentEnum["LANG"] = "LANG";
    EmploymentEnum["ANG"] = "ANG";
    EmploymentEnum["FARB"] = "FARB";
    EmploymentEnum["ARB"] = "ARB";
    EmploymentEnum["SAIS"] = "SAIS";
    EmploymentEnum["LWP"] = "LWP";
    EmploymentEnum["LWN"] = "LWN";
    EmploymentEnum["STD"] = "STD";
    EmploymentEnum["HH"] = "HH";
    EmploymentEnum["PEN"] = "PEN";
    EmploymentEnum["OBB"] = "OBB";
    EmploymentEnum["POST"] = "POST";
    EmploymentEnum["ZHR"] = "ZHR";
    EmploymentEnum["SONST"] = "SONST";
    EmploymentEnum["NB"] = "NB";
})(EmploymentEnum || (EmploymentEnum = {}));
export var EducationEnum;
(function (EducationEnum) {
    EducationEnum["UNBEKANNT"] = "UNB";
    EducationEnum["PFLICHTSCHULE"] = "P";
    EducationEnum["HANDELSSCHULE"] = "H";
    EducationEnum["MATURA_ABITUR"] = "M";
    EducationEnum["U"] = "U";
})(EducationEnum || (EducationEnum = {}));
export var LegalFormEnum;
(function (LegalFormEnum) {
    LegalFormEnum["UNB"] = "UNB";
    LegalFormEnum["AGE"] = "AGE";
    LegalFormEnum["GMBH"] = "GMBH";
    LegalFormEnum["GEMBHCOKG"] = "GEMBHCOKG";
    LegalFormEnum["OG"] = "OG";
    LegalFormEnum["KG"] = "KG";
    LegalFormEnum["EINZL"] = "EINZL";
    LegalFormEnum["GENMBH"] = "GENMBH";
    LegalFormEnum["GESBR"] = "GESBR";
    LegalFormEnum["GMBHCOKG"] = "GMBHCOKG";
    LegalFormEnum["GMBHCOOG"] = "GMBHCOOG";
    LegalFormEnum["GESAUSLRECHT"] = "GESAUSLRECHT";
    LegalFormEnum["SONSTIGE"] = "SONSTIGE";
    LegalFormEnum["GENOSS"] = "GENOSS";
    LegalFormEnum["GESSOEZ"] = "GESSOEZ";
    LegalFormEnum["EINFGES"] = "EINFGES";
    LegalFormEnum["GESLLMITERW"] = "GESLLMITERW";
    LegalFormEnum["HOLDING"] = "HOLDING";
    LegalFormEnum["KOLLGES"] = "KOLLGES";
    LegalFormEnum["ARBGEM"] = "ARBGEM";
    LegalFormEnum["GESMITEINGES"] = "GESMITEINGES";
    LegalFormEnum["STIFTUNG"] = "STIFTUNG";
    LegalFormEnum["KGAUFAKTIEN"] = "KGAUFAKTIEN";
    LegalFormEnum["KOERPOEFFRE"] = "KOERPOEFFRE";
    LegalFormEnum["VEREIN"] = "VEREIN";
    LegalFormEnum["FLEXKAPG"] = "FLEXKAPG";
})(LegalFormEnum || (LegalFormEnum = {}));
export var CommunicationRoleEnum;
(function (CommunicationRoleEnum) {
    CommunicationRoleEnum["HWS"] = "HWS";
    CommunicationRoleEnum["NWS"] = "NWS";
    CommunicationRoleEnum["FIRM"] = "FIRM";
    CommunicationRoleEnum["KA"] = "KA";
    CommunicationRoleEnum["BS"] = "BS";
    CommunicationRoleEnum["WA"] = "WA";
    CommunicationRoleEnum["TH"] = "TH";
    CommunicationRoleEnum["TW"] = "TW";
    CommunicationRoleEnum["EH"] = "EH";
    CommunicationRoleEnum["EW"] = "EW";
    CommunicationRoleEnum["ZUS"] = "ZUS";
})(CommunicationRoleEnum || (CommunicationRoleEnum = {}));
export var FixedPartyEnum;
(function (FixedPartyEnum) {
    FixedPartyEnum["KEIN"] = "U";
    FixedPartyEnum["TEILUNGSABKOMMEN"] = "A";
    FixedPartyEnum["BANK"] = "B";
    FixedPartyEnum["ZULASSUNGSSTELLEN"] = "C";
    FixedPartyEnum["HANDWERKER"] = "D";
    FixedPartyEnum["GERICHTE"] = "G";
    FixedPartyEnum["HOSPITAL"] = "H";
    FixedPartyEnum["SONSTIGE"] = "J";
    FixedPartyEnum["KUNDENGRUPPE"] = "K";
    FixedPartyEnum["AERZTE"] = "O";
    FixedPartyEnum["PARTNERANWAELTE"] = "P";
    FixedPartyEnum["RECHTSANWAELTE"] = "R";
    FixedPartyEnum["SACHVERSTAENDIGEN"] = "S";
    FixedPartyEnum["VERSICHERUNG"] = "V";
    FixedPartyEnum["WERKSTATT"] = "W";
    FixedPartyEnum["KEINE_DAUERPARTNER"] = "N";
    FixedPartyEnum["MIETER"] = "M";
    FixedPartyEnum["SONDERFAELLE"] = "T";
    FixedPartyEnum["ZURICH_KOSMOS"] = "Z";
})(FixedPartyEnum || (FixedPartyEnum = {}));
export var AccountTypeEnum;
(function (AccountTypeEnum) {
    AccountTypeEnum["BK"] = "BK";
})(AccountTypeEnum || (AccountTypeEnum = {}));
export var InsolvencyEnum;
(function (InsolvencyEnum) {
    InsolvencyEnum["SANIERUNGSVERFAHREN169"] = "SANIERUNGSVERFAHREN169";
    InsolvencyEnum["SANIERUNGSVERFAHREN166"] = "SANIERUNGSVERFAHREN166";
    InsolvencyEnum["KONKURSVERFAHREN"] = "KONKURSVERFAHREN";
    InsolvencyEnum["SCHULDENREGULIERUNGSVERFAHREN"] = "SCHULDENREGULIERUNGSVERFAHREN";
    InsolvencyEnum["KONKURS"] = "KONKURS";
    InsolvencyEnum["AUSGLEICH"] = "AUSGLEICH";
})(InsolvencyEnum || (InsolvencyEnum = {}));
export var ConsentPurposeEnum;
(function (ConsentPurposeEnum) {
    ConsentPurposeEnum["UNB"] = "UNB";
    ConsentPurposeEnum["NEW"] = "NEW";
    ConsentPurposeEnum["FIN"] = "FIN";
    ConsentPurposeEnum["KWK"] = "KWK";
    ConsentPurposeEnum["ELK"] = "ELK";
    ConsentPurposeEnum["SMU"] = "SMU";
    ConsentPurposeEnum["SVW"] = "SVW";
    ConsentPurposeEnum["AUR"] = "AUR";
    ConsentPurposeEnum["MAR"] = "MAR";
    ConsentPurposeEnum["BEF"] = "BEF";
})(ConsentPurposeEnum || (ConsentPurposeEnum = {}));
export var SearchMatchTypeEnum;
(function (SearchMatchTypeEnum) {
    SearchMatchTypeEnum["EQUALS"] = "EQUALS";
    SearchMatchTypeEnum["STARTS_WITH"] = "STARTS_WITH";
    SearchMatchTypeEnum["CONTAINS"] = "CONTAINS";
    SearchMatchTypeEnum["PHONETIC"] = "PHONETIC";
})(SearchMatchTypeEnum || (SearchMatchTypeEnum = {}));
export var SearchEntriesTypeEnum;
(function (SearchEntriesTypeEnum) {
    SearchEntriesTypeEnum["ACTIVE"] = "ACTIVE";
    SearchEntriesTypeEnum["HISTORY"] = "HISTORY";
    SearchEntriesTypeEnum["ACTIVE_HIST"] = "ACTIVE_HIST";
})(SearchEntriesTypeEnum || (SearchEntriesTypeEnum = {}));
export var OrganizationTypeEnum;
(function (OrganizationTypeEnum) {
    OrganizationTypeEnum["UNBEKANNT"] = "UNB";
    OrganizationTypeEnum["FREIE_BERUFE"] = "B";
    OrganizationTypeEnum["FIRMEN"] = "F";
    OrganizationTypeEnum["INDUSTRIE"] = "I";
    OrganizationTypeEnum["LANDWIRT"] = "L";
    OrganizationTypeEnum["ORGANISATION"] = "O";
    OrganizationTypeEnum["VEREIN"] = "V";
    OrganizationTypeEnum["ZUERICH_INTERNATIONAL"] = "Z";
    OrganizationTypeEnum["K"] = "K";
})(OrganizationTypeEnum || (OrganizationTypeEnum = {}));
export var CommunicationLockEnum;
(function (CommunicationLockEnum) {
    CommunicationLockEnum["UNB"] = "UNB";
    CommunicationLockEnum["AVV"] = "AVV";
    CommunicationLockEnum["APE"] = "APE";
    CommunicationLockEnum["APT"] = "APT";
    CommunicationLockEnum["AET"] = "AET";
    CommunicationLockEnum["WSE"] = "WSE";
    CommunicationLockEnum["ANE"] = "ANE";
    CommunicationLockEnum["KHE"] = "KHE";
})(CommunicationLockEnum || (CommunicationLockEnum = {}));
export var PartyTypeEnum;
(function (PartyTypeEnum) {
    PartyTypeEnum["J"] = "J";
    PartyTypeEnum["N"] = "N";
})(PartyTypeEnum || (PartyTypeEnum = {}));
export var PartySubTypeEnum;
(function (PartySubTypeEnum) {
    PartySubTypeEnum["PRIVATPERSON"] = "P";
    PartySubTypeEnum["EINZELUNTERNEHMER"] = "E";
    PartySubTypeEnum["VEREIN"] = "V";
    PartySubTypeEnum["UNTERNEHMEN"] = "U";
})(PartySubTypeEnum || (PartySubTypeEnum = {}));
export var PartyNoteTypeEnum;
(function (PartyNoteTypeEnum) {
    PartyNoteTypeEnum["ANRUF_DURCHGEFUHRT"] = "ANRUF_DURCHGEFUHRT";
    PartyNoteTypeEnum["ANRUF_ERHALTEN"] = "ANRUF_ERHALTEN";
    PartyNoteTypeEnum["EMAIL_ERHALTEN"] = "EMAIL_ERHALTEN";
    PartyNoteTypeEnum["EMAIL_VERSENDET"] = "EMAIL_VERSENDET";
    PartyNoteTypeEnum["INTERN"] = "INTERN";
})(PartyNoteTypeEnum || (PartyNoteTypeEnum = {}));
export var GenderEnum;
(function (GenderEnum) {
    GenderEnum["UNKNOWN"] = "U";
    GenderEnum["MALE"] = "M";
    GenderEnum["FEMALE"] = "F";
    GenderEnum["DIVERS"] = "D";
    GenderEnum["INTER"] = "I";
    GenderEnum["OPENED"] = "O";
    GenderEnum["K"] = "K";
})(GenderEnum || (GenderEnum = {}));
export var PostHouseholdStatusEnum;
(function (PostHouseholdStatusEnum) {
    PostHouseholdStatusEnum["ACTIVE_HOUSEHOLD"] = "A";
    PostHouseholdStatusEnum["INACTIVE_HOUSEHOLD"] = "I";
    PostHouseholdStatusEnum["CORRECTED_HOUSEHOLD"] = "K";
    PostHouseholdStatusEnum["STREET_ENTRY"] = "G";
    PostHouseholdStatusEnum["DUMMY"] = "D";
})(PostHouseholdStatusEnum || (PostHouseholdStatusEnum = {}));
export var PostHouseholdTypeEnum;
(function (PostHouseholdTypeEnum) {
    PostHouseholdTypeEnum["PRIVAT_GENUTZT"] = "PRIVAT_GENUTZT";
    PostHouseholdTypeEnum["KEINE_PRIVATE_NUTZUNG_OR_UNTERNHEMEN_OR_OFFENTLICHE_EINRICHTUNGEN_OR_GEWERBE"] = "KEINE_PRIVATE_NUTZUNG_OR_UNTERNHEMEN_OR_OFFENTLICHE_EINRICHTUNGEN_OR_GEWERBE";
    PostHouseholdTypeEnum["ZWEIT_ODER_FERIENWOHNSITZ"] = "ZWEIT_ODER_FERIENWOHNSITZ";
})(PostHouseholdTypeEnum || (PostHouseholdTypeEnum = {}));
export var CommunicationTypeEnum;
(function (CommunicationTypeEnum) {
    CommunicationTypeEnum["POSTBOX"] = "POSTBOX";
    CommunicationTypeEnum["GEO"] = "GEO";
    CommunicationTypeEnum["TELEPHONE"] = "TELEPHONE";
    CommunicationTypeEnum["EMAIL"] = "EMAIL";
})(CommunicationTypeEnum || (CommunicationTypeEnum = {}));
export var PhoneIsMobileNumberEnum;
(function (PhoneIsMobileNumberEnum) {
    PhoneIsMobileNumberEnum["JA"] = "JA";
    PhoneIsMobileNumberEnum["NEIN"] = "NEIN";
    PhoneIsMobileNumberEnum["UNBESTIMMT"] = "UNBESTIMMT";
})(PhoneIsMobileNumberEnum || (PhoneIsMobileNumberEnum = {}));
export var DiplomaticStatusEnum;
(function (DiplomaticStatusEnum) {
    DiplomaticStatusEnum[DiplomaticStatusEnum["ROT"] = 4] = "ROT";
    DiplomaticStatusEnum[DiplomaticStatusEnum["ORANGE"] = 5] = "ORANGE";
    DiplomaticStatusEnum[DiplomaticStatusEnum["GELB"] = 6] = "GELB";
    DiplomaticStatusEnum[DiplomaticStatusEnum["GRUEN"] = 7] = "GRUEN";
    DiplomaticStatusEnum[DiplomaticStatusEnum["BLAU"] = 8] = "BLAU";
    DiplomaticStatusEnum[DiplomaticStatusEnum["BRAUN"] = 3] = "BRAUN";
    DiplomaticStatusEnum[DiplomaticStatusEnum["WEISS_GRAU"] = 9] = "WEISS_GRAU";
    DiplomaticStatusEnum[DiplomaticStatusEnum["IO"] = 99] = "IO";
    DiplomaticStatusEnum[DiplomaticStatusEnum["VIOLETT"] = 10] = "VIOLETT";
})(DiplomaticStatusEnum || (DiplomaticStatusEnum = {}));
export var OccupationEnum;
(function (OccupationEnum) {
    OccupationEnum["UNBEK"] = "UNBEK";
    OccupationEnum["ALTWA"] = "ALTWA";
    OccupationEnum["ANGES"] = "ANGES";
    OccupationEnum["ANIMA"] = "ANIMA";
    OccupationEnum["ANTIQ"] = "ANTIQ";
    OccupationEnum["APOTH"] = "APOTH";
    OccupationEnum["ARCHI"] = "ARCHI";
    OccupationEnum["ARTIS"] = "ARTIS";
    OccupationEnum["ARZT"] = "ARZT";
    OccupationEnum["ARZTH"] = "ARZTH";
    OccupationEnum["ASPHA"] = "ASPHA";
    OccupationEnum["ASSIS"] = "ASSIS";
    OccupationEnum["AUTOH"] = "AUTOH";
    OccupationEnum["AUTOV"] = "AUTOV";
    OccupationEnum["BAECKE"] = "BAECKE";
    OccupationEnum["BADEW"] = "BADEW";
    OccupationEnum["BAHNP1"] = "BAHNP1";
    OccupationEnum["BAHNP2"] = "BAHNP2";
    OccupationEnum["BANDA"] = "BANDA";
    OccupationEnum["BANKA"] = "BANKA";
    OccupationEnum["BARPE"] = "BARPE";
    OccupationEnum["BAUBE"] = "BAUBE";
    OccupationEnum["BEAMT"] = "BEAMT";
    OccupationEnum["BERAT"] = "BERAT";
    OccupationEnum["BERGF"] = "BERGF";
    OccupationEnum["BERGL"] = "BERGL";
    OccupationEnum["BERGR"] = "BERGR";
    OccupationEnum["BERUF1"] = "BERUF1";
    OccupationEnum["BERUF2"] = "BERUF2";
    OccupationEnum["BERUF3"] = "BERUF3";
    OccupationEnum["BETRI"] = "BETRI";
    OccupationEnum["BEWAEH"] = "BEWAEH";
    OccupationEnum["BIBLI"] = "BIBLI";
    OccupationEnum["BIOLO"] = "BIOLO";
    OccupationEnum["BODEN"] = "BODEN";
    OccupationEnum["BODYG"] = "BODYG";
    OccupationEnum["BOHRA"] = "BOHRA";
    OccupationEnum["BOTAN"] = "BOTAN";
    OccupationEnum["BOTE"] = "BOTE";
    OccupationEnum["BRAUE"] = "BRAUE";
    OccupationEnum["BRENN1"] = "BRENN1";
    OccupationEnum["BRENN2"] = "BRENN2";
    OccupationEnum["BRIEF"] = "BRIEF";
    OccupationEnum["BUCHB"] = "BUCHB";
    OccupationEnum["BUCHD"] = "BUCHD";
    OccupationEnum["BUCHH"] = "BUCHH";
    OccupationEnum["BUCHM"] = "BUCHM";
    OccupationEnum["BUNDE"] = "BUNDE";
    OccupationEnum["BUEROB"] = "BUEROB";
    OccupationEnum["CHEMI1"] = "CHEMI1";
    OccupationEnum["CHEMI2"] = "CHEMI2";
    OccupationEnum["CHEMI3"] = "CHEMI3";
    OccupationEnum["CHIRO"] = "CHIRO";
    OccupationEnum["CROUP"] = "CROUP";
    OccupationEnum["DACHD"] = "DACHD";
    OccupationEnum["DEKOR"] = "DEKOR";
    OccupationEnum["DENTI"] = "DENTI";
    OccupationEnum["DESIG"] = "DESIG";
    OccupationEnum["DIENS"] = "DIENS";
    OccupationEnum["DOLME"] = "DOLME";
    OccupationEnum["DRECH"] = "DRECH";
    OccupationEnum["DREHE"] = "DREHE";
    OccupationEnum["DROGI"] = "DROGI";
    OccupationEnum["DRUCK"] = "DRUCK";
    OccupationEnum["EDVB"] = "EDVB";
    OccupationEnum["ELEKT1"] = "ELEKT1";
    OccupationEnum["ELEKT2"] = "ELEKT2";
    OccupationEnum["ELEKT3"] = "ELEKT3";
    OccupationEnum["ELEKT4"] = "ELEKT4";
    OccupationEnum["FABRI"] = "FABRI";
    OccupationEnum["FACHA"] = "FACHA";
    OccupationEnum["FAHRE"] = "FAHRE";
    OccupationEnum["FAHRL"] = "FAHRL";
    OccupationEnum["FASSBI"] = "FASSBI";
    OccupationEnum["FEINM"] = "FEINM";
    OccupationEnum["FERNM"] = "FERNM";
    OccupationEnum["FILM"] = "FILM";
    OccupationEnum["FILMV"] = "FILMV";
    OccupationEnum["FLEIS"] = "FLEIS";
    OccupationEnum["FLIES"] = "FLIES";
    OccupationEnum["FLORI"] = "FLORI";
    OccupationEnum["FLUGB"] = "FLUGB";
    OccupationEnum["FORST1"] = "FORST1";
    OccupationEnum["FORST2"] = "FORST2";
    OccupationEnum["FOERST"] = "FOERST";
    OccupationEnum["FOTOG"] = "FOTOG";
    OccupationEnum["FOTOL"] = "FOTOL";
    OccupationEnum["FRAECH"] = "FRAECH";
    OccupationEnum["FREMD1"] = "FREMD1";
    OccupationEnum["FREMD2"] = "FREMD2";
    OccupationEnum["FRISE"] = "FRISE";
    OccupationEnum["FUHRW"] = "FUHRW";
    OccupationEnum["FUERSO"] = "FUERSO";
    OccupationEnum["GALVA"] = "GALVA";
    OccupationEnum["GARTE"] = "GARTE";
    OccupationEnum["GAERTN"] = "GAERTN";
    OccupationEnum["GASTW"] = "GASTW";
    OccupationEnum["GEIST"] = "GEIST";
    OccupationEnum["GEOLO"] = "GEOLO";
    OccupationEnum["GERAET"] = "GERAET";
    OccupationEnum["GERUES"] = "GERUES";
    OccupationEnum["GESCH1"] = "GESCH1";
    OccupationEnum["GESCH2"] = "GESCH2";
    OccupationEnum["GETRAE"] = "GETRAE";
    OccupationEnum["GLASA"] = "GLASA";
    OccupationEnum["GLASE"] = "GLASE";
    OccupationEnum["GOLD"] = "GOLD";
    OccupationEnum["GRAFI"] = "GRAFI";
    OccupationEnum["GRAVE"] = "GRAVE";
    OccupationEnum["GROBM"] = "GROBM";
    OccupationEnum["GUMMI"] = "GUMMI";
    OccupationEnum["GUTSB"] = "GUTSB";
    OccupationEnum["GUTSV"] = "GUTSV";
    OccupationEnum["HAFNE"] = "HAFNE";
    OccupationEnum["HANDE"] = "HANDE";
    OccupationEnum["HAENDL"] = "HAENDL";
    OccupationEnum["HAUSG"] = "HAUSG";
    OccupationEnum["HAUSF"] = "HAUSF";
    OccupationEnum["HAUSM"] = "HAUSM";
    OccupationEnum["HAUSH"] = "HAUSH";
    OccupationEnum["HAUSV"] = "HAUSV";
    OccupationEnum["HAUSW"] = "HAUSW";
    OccupationEnum["HEBAM"] = "HEBAM";
    OccupationEnum["HEILP"] = "HEILP";
    OccupationEnum["HEIMV"] = "HEIMV";
    OccupationEnum["HEIZE"] = "HEIZE";
    OccupationEnum["HEIZU"] = "HEIZU";
    OccupationEnum["HILFS"] = "HILFS";
    OccupationEnum["HOCHS"] = "HOCHS";
    OccupationEnum["HOLZB"] = "HOLZB";
    OccupationEnum["HOLZM"] = "HOLZM";
    OccupationEnum["HOTEL1"] = "HOTEL1";
    OccupationEnum["HOTEL2"] = "HOTEL2";
    OccupationEnum["IMKER"] = "IMKER";
    OccupationEnum["INFOR"] = "INFOR";
    OccupationEnum["INSTA"] = "INSTA";
    OccupationEnum["INSTR"] = "INSTR";
    OccupationEnum["ISOLI"] = "ISOLI";
    OccupationEnum["JAGDB"] = "JAGDB";
    OccupationEnum["JOCKE"] = "JOCKE";
    OccupationEnum["JOURN"] = "JOURN";
    OccupationEnum["JURIS"] = "JURIS";
    OccupationEnum["JUWEL"] = "JUWEL";
    OccupationEnum["KABEL"] = "KABEL";
    OccupationEnum["KAMER"] = "KAMER";
    OccupationEnum["KANAL"] = "KANAL";
    OccupationEnum["KAUFM1"] = "KAUFM1";
    OccupationEnum["KAUFM2"] = "KAUFM2";
    OccupationEnum["KELLN"] = "KELLN";
    OccupationEnum["KERAM"] = "KERAM";
    OccupationEnum["KFZM"] = "KFZM";
    OccupationEnum["KIND"] = "KIND";
    OccupationEnum["KINDE"] = "KINDE";
    OccupationEnum["KLEID"] = "KLEID";
    OccupationEnum["KOCH"] = "KOCH";
    OccupationEnum["KONST"] = "KONST";
    OccupationEnum["KONSU1"] = "KONSU1";
    OccupationEnum["KONSU2"] = "KONSU2";
    OccupationEnum["KORBM"] = "KORBM";
    OccupationEnum["KORRE"] = "KORRE";
    OccupationEnum["KOSME"] = "KOSME";
    OccupationEnum["KRAFT"] = "KRAFT";
    OccupationEnum["KRANK1"] = "KRANK1";
    OccupationEnum["KRANK2"] = "KRANK2";
    OccupationEnum["KRIMI"] = "KRIMI";
    OccupationEnum["KUNST1"] = "KUNST1";
    OccupationEnum["KUNST2"] = "KUNST2";
    OccupationEnum["KUENST"] = "KUENST";
    OccupationEnum["KUERSC"] = "KUERSC";
    OccupationEnum["LABOR"] = "LABOR";
    OccupationEnum["LACKI"] = "LACKI";
    OccupationEnum["LADEN"] = "LADEN";
    OccupationEnum["LAGER1"] = "LAGER1";
    OccupationEnum["LAGER2"] = "LAGER2";
    OccupationEnum["LANDA"] = "LANDA";
    OccupationEnum["LANDM"] = "LANDM";
    OccupationEnum["LANDW"] = "LANDW";
    OccupationEnum["LEBEN"] = "LEBEN";
    OccupationEnum["LEHRE"] = "LEHRE";
    OccupationEnum["LEHRL1"] = "LEHRL1";
    OccupationEnum["LEHRL2"] = "LEHRL2";
    OccupationEnum["LEICH"] = "LEICH";
    OccupationEnum["LEKTO"] = "LEKTO";
    OccupationEnum["LUFTV"] = "LUFTV";
    OccupationEnum["MAKLE"] = "MAKLE";
    OccupationEnum["MALER"] = "MALER";
    OccupationEnum["MANAG"] = "MANAG";
    OccupationEnum["MANNE"] = "MANNE";
    OccupationEnum["MARKT"] = "MARKT";
    OccupationEnum["MASCH1"] = "MASCH1";
    OccupationEnum["MASCH2"] = "MASCH2";
    OccupationEnum["MASKE"] = "MASKE";
    OccupationEnum["MASSE"] = "MASSE";
    OccupationEnum["MAURE"] = "MAURE";
    OccupationEnum["MECHA"] = "MECHA";
    OccupationEnum["MED"] = "MED";
    OccupationEnum["METAL"] = "METAL";
    OccupationEnum["MOLKE"] = "MOLKE";
    OccupationEnum["MOENCH"] = "MOENCH";
    OccupationEnum["MONTA"] = "MONTA";
    OccupationEnum["MUEHLE"] = "MUEHLE";
    OccupationEnum["MUELLA"] = "MUELLA";
    OccupationEnum["MUELLE"] = "MUELLE";
    OccupationEnum["MUSIK"] = "MUSIK";
    OccupationEnum["NACHR"] = "NACHR";
    OccupationEnum["NAHRU"] = "NAHRU";
    OccupationEnum["NICHT"] = "NICHT";
    OccupationEnum["NOTAR"] = "NOTAR";
    OccupationEnum["OFENS"] = "OFENS";
    OccupationEnum["OPTIK"] = "OPTIK";
    OccupationEnum["ORDIN"] = "ORDIN";
    OccupationEnum["PACKE"] = "PACKE";
    OccupationEnum["PANNE"] = "PANNE";
    OccupationEnum["PAPIE"] = "PAPIE";
    OccupationEnum["PENSI"] = "PENSI";
    OccupationEnum["PHARM1"] = "PHARM1";
    OccupationEnum["PHARM2"] = "PHARM2";
    OccupationEnum["PHYSI"] = "PHYSI";
    OccupationEnum["POLIE"] = "POLIE";
    OccupationEnum["POLIT"] = "POLIT";
    OccupationEnum["POLIZ1"] = "POLIZ1";
    OccupationEnum["POLIZ2"] = "POLIZ2";
    OccupationEnum["POLST"] = "POLST";
    OccupationEnum["PORTI"] = "PORTI";
    OccupationEnum["POSTV"] = "POSTV";
    OccupationEnum["PRIVA"] = "PRIVA";
    OccupationEnum["PSYCH1"] = "PSYCH1";
    OccupationEnum["PSYCH2"] = "PSYCH2";
    OccupationEnum["PYROT"] = "PYROT";
    OccupationEnum["RADIO"] = "RADIO";
    OccupationEnum["RAUCH"] = "RAUCH";
    OccupationEnum["RAUMA"] = "RAUMA";
    OccupationEnum["RECHT"] = "RECHT";
    OccupationEnum["REINI"] = "REINI";
    OccupationEnum["REPOR"] = "REPOR";
    OccupationEnum["RESTA"] = "RESTA";
    OccupationEnum["RICHT"] = "RICHT";
    OccupationEnum["ROHRI"] = "ROHRI";
    OccupationEnum["SACHB"] = "SACHB";
    OccupationEnum["SAEGEW"] = "SAEGEW";
    OccupationEnum["SANIT"] = "SANIT";
    OccupationEnum["SCHAED"] = "SCHAED";
    OccupationEnum["SCHAF"] = "SCHAF";
    OccupationEnum["SCHIF"] = "SCHIF";
    OccupationEnum["SCHIL"] = "SCHIL";
    OccupationEnum["SCHLO"] = "SCHLO";
    OccupationEnum["SCHMI"] = "SCHMI";
    OccupationEnum["SCHNE"] = "SCHNE";
    OccupationEnum["SCHRI"] = "SCHRI";
    OccupationEnum["SCHUEL"] = "SCHUEL";
    OccupationEnum["SCHUS"] = "SCHUS";
    OccupationEnum["SCHWE"] = "SCHWE";
    OccupationEnum["SEKRE"] = "SEKRE";
    OccupationEnum["SETZE"] = "SETZE";
    OccupationEnum["SOLDA"] = "SOLDA";
    OccupationEnum["SONDE"] = "SONDE";
    OccupationEnum["SONST1"] = "SONST1";
    OccupationEnum["SONST2"] = "SONST2";
    OccupationEnum["SOZIA"] = "SOZIA";
    OccupationEnum["SOZIO"] = "SOZIO";
    OccupationEnum["SPEDI"] = "SPEDI";
    OccupationEnum["SPEIS"] = "SPEIS";
    OccupationEnum["SPENG"] = "SPENG";
    OccupationEnum["SPIEL"] = "SPIEL";
    OccupationEnum["SPREN"] = "SPREN";
    OccupationEnum["STAAT"] = "STAAT";
    OccupationEnum["STATI"] = "STATI";
    OccupationEnum["STEIN"] = "STEIN";
    OccupationEnum["STEUE"] = "STEUE";
    OccupationEnum["STOFF"] = "STOFF";
    OccupationEnum["STRASS"] = "STRASS";
    OccupationEnum["STUDE"] = "STUDE";
    OccupationEnum["STUKK"] = "STUKK";
    OccupationEnum["STUNT"] = "STUNT";
    OccupationEnum["TANKW"] = "TANKW";
    OccupationEnum["TAENZE"] = "TAENZE";
    OccupationEnum["TAPEZ"] = "TAPEZ";
    OccupationEnum["TAXIF"] = "TAXIF";
    OccupationEnum["TECHN1"] = "TECHN1";
    OccupationEnum["TECHN2"] = "TECHN2";
    OccupationEnum["TECHN3"] = "TECHN3";
    OccupationEnum["TECHN4"] = "TECHN4";
    OccupationEnum["TECHN5"] = "TECHN5";
    OccupationEnum["TECHN6"] = "TECHN6";
    OccupationEnum["TECHN7"] = "TECHN7";
    OccupationEnum["TECHN8"] = "TECHN8";
    OccupationEnum["TECHN9"] = "TECHN9";
    OccupationEnum["TECHN10"] = "TECHN10";
    OccupationEnum["TECHN11"] = "TECHN11";
    OccupationEnum["TECHN12"] = "TECHN12";
    OccupationEnum["TECHN13"] = "TECHN13";
    OccupationEnum["TELEF"] = "TELEF";
    OccupationEnum["TEXTI1"] = "TEXTI1";
    OccupationEnum["TEXTI2"] = "TEXTI2";
    OccupationEnum["THERA"] = "THERA";
    OccupationEnum["TIERA"] = "TIERA";
    OccupationEnum["TIERF"] = "TIERF";
    OccupationEnum["TIERH"] = "TIERH";
    OccupationEnum["TIERP"] = "TIERP";
    OccupationEnum["TIERZ"] = "TIERZ";
    OccupationEnum["TISCH"] = "TISCH";
    OccupationEnum["TRAFI"] = "TRAFI";
    OccupationEnum["TRAIN1"] = "TRAIN1";
    OccupationEnum["TRAIN2"] = "TRAIN2";
    OccupationEnum["TRANS"] = "TRANS";
    OccupationEnum["UHRMA"] = "UHRMA";
    OccupationEnum["UNTER1"] = "UNTER1";
    OccupationEnum["UNTER2"] = "UNTER2";
    OccupationEnum["UNTER3"] = "UNTER3";
    OccupationEnum["VERKAE"] = "VERKAE";
    OccupationEnum["VERMOE"] = "VERMOE";
    OccupationEnum["VERSI1"] = "VERSI1";
    OccupationEnum["VERSI2"] = "VERSI2";
    OccupationEnum["VERTR"] = "VERTR";
    OccupationEnum["VERWA"] = "VERWA";
    OccupationEnum["WACHE1"] = "WACHE1";
    OccupationEnum["WACHE2"] = "WACHE2";
    OccupationEnum["WAREN"] = "WAREN";
    OccupationEnum["WEBER"] = "WEBER";
    OccupationEnum["WEINB"] = "WEINB";
    OccupationEnum["WERBE"] = "WERBE";
    OccupationEnum["WERKM"] = "WERKM";
    OccupationEnum["WERKZ"] = "WERKZ";
    OccupationEnum["WIRTS1"] = "WIRTS1";
    OccupationEnum["WIRTS2"] = "WIRTS2";
    OccupationEnum["WIRTS3"] = "WIRTS3";
    OccupationEnum["WIRTS4"] = "WIRTS4";
    OccupationEnum["WISSE"] = "WISSE";
    OccupationEnum["ZAHNA"] = "ZAHNA";
    OccupationEnum["ZAHNT"] = "ZAHNT";
    OccupationEnum["ZIEGE"] = "ZIEGE";
    OccupationEnum["ZIMME"] = "ZIMME";
    OccupationEnum["ZIVIL"] = "ZIVIL";
    OccupationEnum["ZOLLB"] = "ZOLLB";
    OccupationEnum["ZUCKE"] = "ZUCKE";
    OccupationEnum["ZUGFUE"] = "ZUGFUE";
})(OccupationEnum || (OccupationEnum = {}));
export var LanguageIsoCodeEnum;
(function (LanguageIsoCodeEnum) {
    LanguageIsoCodeEnum["AAR"] = "AAR";
    LanguageIsoCodeEnum["ABK"] = "ABK";
    LanguageIsoCodeEnum["AFR"] = "AFR";
    LanguageIsoCodeEnum["AKA"] = "AKA";
    LanguageIsoCodeEnum["AMH"] = "AMH";
    LanguageIsoCodeEnum["ARA"] = "ARA";
    LanguageIsoCodeEnum["ARG"] = "ARG";
    LanguageIsoCodeEnum["ASM"] = "ASM";
    LanguageIsoCodeEnum["AVA"] = "AVA";
    LanguageIsoCodeEnum["AVE"] = "AVE";
    LanguageIsoCodeEnum["AYM"] = "AYM";
    LanguageIsoCodeEnum["AZE"] = "AZE";
    LanguageIsoCodeEnum["BAK"] = "BAK";
    LanguageIsoCodeEnum["BAM"] = "BAM";
    LanguageIsoCodeEnum["BEL"] = "BEL";
    LanguageIsoCodeEnum["BEN"] = "BEN";
    LanguageIsoCodeEnum["BIH"] = "BIH";
    LanguageIsoCodeEnum["BIS"] = "BIS";
    LanguageIsoCodeEnum["BOD"] = "BOD";
    LanguageIsoCodeEnum["BOS"] = "BOS";
    LanguageIsoCodeEnum["BRE"] = "BRE";
    LanguageIsoCodeEnum["BUL"] = "BUL";
    LanguageIsoCodeEnum["CAT"] = "CAT";
    LanguageIsoCodeEnum["CES"] = "CES";
    LanguageIsoCodeEnum["CHA"] = "CHA";
    LanguageIsoCodeEnum["CHE"] = "CHE";
    LanguageIsoCodeEnum["CHU"] = "CHU";
    LanguageIsoCodeEnum["CHV"] = "CHV";
    LanguageIsoCodeEnum["COR"] = "COR";
    LanguageIsoCodeEnum["COS"] = "COS";
    LanguageIsoCodeEnum["CRE"] = "CRE";
    LanguageIsoCodeEnum["CYM"] = "CYM";
    LanguageIsoCodeEnum["DAN"] = "DAN";
    LanguageIsoCodeEnum["DEU"] = "DEU";
    LanguageIsoCodeEnum["DIV"] = "DIV";
    LanguageIsoCodeEnum["DZO"] = "DZO";
    LanguageIsoCodeEnum["ELL"] = "ELL";
    LanguageIsoCodeEnum["ENG"] = "ENG";
    LanguageIsoCodeEnum["EPO"] = "EPO";
    LanguageIsoCodeEnum["EST"] = "EST";
    LanguageIsoCodeEnum["EUS"] = "EUS";
    LanguageIsoCodeEnum["EWE"] = "EWE";
    LanguageIsoCodeEnum["FAO"] = "FAO";
    LanguageIsoCodeEnum["FAS"] = "FAS";
    LanguageIsoCodeEnum["FIJ"] = "FIJ";
    LanguageIsoCodeEnum["FIN"] = "FIN";
    LanguageIsoCodeEnum["FRA"] = "FRA";
    LanguageIsoCodeEnum["FRY"] = "FRY";
    LanguageIsoCodeEnum["FUL"] = "FUL";
    LanguageIsoCodeEnum["GLA"] = "GLA";
    LanguageIsoCodeEnum["GLE"] = "GLE";
    LanguageIsoCodeEnum["GLG"] = "GLG";
    LanguageIsoCodeEnum["GLV"] = "GLV";
    LanguageIsoCodeEnum["GRN"] = "GRN";
    LanguageIsoCodeEnum["GUJ"] = "GUJ";
    LanguageIsoCodeEnum["HAT"] = "HAT";
    LanguageIsoCodeEnum["HAU"] = "HAU";
    LanguageIsoCodeEnum["HBS"] = "HBS";
    LanguageIsoCodeEnum["HEB"] = "HEB";
    LanguageIsoCodeEnum["HER"] = "HER";
    LanguageIsoCodeEnum["HIN"] = "HIN";
    LanguageIsoCodeEnum["HMO"] = "HMO";
    LanguageIsoCodeEnum["HRV"] = "HRV";
    LanguageIsoCodeEnum["HUN"] = "HUN";
    LanguageIsoCodeEnum["HYE"] = "HYE";
    LanguageIsoCodeEnum["IBO"] = "IBO";
    LanguageIsoCodeEnum["IDO"] = "IDO";
    LanguageIsoCodeEnum["III"] = "III";
    LanguageIsoCodeEnum["IKU"] = "IKU";
    LanguageIsoCodeEnum["ILE"] = "ILE";
    LanguageIsoCodeEnum["INA"] = "INA";
    LanguageIsoCodeEnum["IND"] = "IND";
    LanguageIsoCodeEnum["IPK"] = "IPK";
    LanguageIsoCodeEnum["ISL"] = "ISL";
    LanguageIsoCodeEnum["ITA"] = "ITA";
    LanguageIsoCodeEnum["JAV"] = "JAV";
    LanguageIsoCodeEnum["JPN"] = "JPN";
    LanguageIsoCodeEnum["KAL"] = "KAL";
    LanguageIsoCodeEnum["KAN"] = "KAN";
    LanguageIsoCodeEnum["KAS"] = "KAS";
    LanguageIsoCodeEnum["KAT"] = "KAT";
    LanguageIsoCodeEnum["KAU"] = "KAU";
    LanguageIsoCodeEnum["KAZ"] = "KAZ";
    LanguageIsoCodeEnum["KHM"] = "KHM";
    LanguageIsoCodeEnum["KIK"] = "KIK";
    LanguageIsoCodeEnum["KIN"] = "KIN";
    LanguageIsoCodeEnum["KIR"] = "KIR";
    LanguageIsoCodeEnum["KOM"] = "KOM";
    LanguageIsoCodeEnum["KON"] = "KON";
    LanguageIsoCodeEnum["KOR"] = "KOR";
    LanguageIsoCodeEnum["KUA"] = "KUA";
    LanguageIsoCodeEnum["KUR"] = "KUR";
    LanguageIsoCodeEnum["LAO"] = "LAO";
    LanguageIsoCodeEnum["LAT"] = "LAT";
    LanguageIsoCodeEnum["LAV"] = "LAV";
    LanguageIsoCodeEnum["LIM"] = "LIM";
    LanguageIsoCodeEnum["LIN"] = "LIN";
    LanguageIsoCodeEnum["LIT"] = "LIT";
    LanguageIsoCodeEnum["LTZ"] = "LTZ";
    LanguageIsoCodeEnum["LUB"] = "LUB";
    LanguageIsoCodeEnum["LUG"] = "LUG";
    LanguageIsoCodeEnum["MAH"] = "MAH";
    LanguageIsoCodeEnum["MAL"] = "MAL";
    LanguageIsoCodeEnum["MAR"] = "MAR";
    LanguageIsoCodeEnum["MKD"] = "MKD";
    LanguageIsoCodeEnum["MLG"] = "MLG";
    LanguageIsoCodeEnum["MLT"] = "MLT";
    LanguageIsoCodeEnum["MON"] = "MON";
    LanguageIsoCodeEnum["MRI"] = "MRI";
    LanguageIsoCodeEnum["MSA"] = "MSA";
    LanguageIsoCodeEnum["MYA"] = "MYA";
    LanguageIsoCodeEnum["NAU"] = "NAU";
    LanguageIsoCodeEnum["NAV"] = "NAV";
    LanguageIsoCodeEnum["NBL"] = "NBL";
    LanguageIsoCodeEnum["NDE"] = "NDE";
    LanguageIsoCodeEnum["NDO"] = "NDO";
    LanguageIsoCodeEnum["NEP"] = "NEP";
    LanguageIsoCodeEnum["NLD"] = "NLD";
    LanguageIsoCodeEnum["NNO"] = "NNO";
    LanguageIsoCodeEnum["NOB"] = "NOB";
    LanguageIsoCodeEnum["NOR"] = "NOR";
    LanguageIsoCodeEnum["NYA"] = "NYA";
    LanguageIsoCodeEnum["OCI"] = "OCI";
    LanguageIsoCodeEnum["OJI"] = "OJI";
    LanguageIsoCodeEnum["ORI"] = "ORI";
    LanguageIsoCodeEnum["ORM"] = "ORM";
    LanguageIsoCodeEnum["OSS"] = "OSS";
    LanguageIsoCodeEnum["PAN"] = "PAN";
    LanguageIsoCodeEnum["PLI"] = "PLI";
    LanguageIsoCodeEnum["POL"] = "POL";
    LanguageIsoCodeEnum["POR"] = "POR";
    LanguageIsoCodeEnum["PUS"] = "PUS";
    LanguageIsoCodeEnum["QUE"] = "QUE";
    LanguageIsoCodeEnum["ROH"] = "ROH";
    LanguageIsoCodeEnum["RON"] = "RON";
    LanguageIsoCodeEnum["RUN"] = "RUN";
    LanguageIsoCodeEnum["RUS"] = "RUS";
    LanguageIsoCodeEnum["SAG"] = "SAG";
    LanguageIsoCodeEnum["SAN"] = "SAN";
    LanguageIsoCodeEnum["SIN"] = "SIN";
    LanguageIsoCodeEnum["SLK"] = "SLK";
    LanguageIsoCodeEnum["SLV"] = "SLV";
    LanguageIsoCodeEnum["SME"] = "SME";
    LanguageIsoCodeEnum["SMO"] = "SMO";
    LanguageIsoCodeEnum["SNA"] = "SNA";
    LanguageIsoCodeEnum["SND"] = "SND";
    LanguageIsoCodeEnum["SOM"] = "SOM";
    LanguageIsoCodeEnum["SOT"] = "SOT";
    LanguageIsoCodeEnum["SPA"] = "SPA";
    LanguageIsoCodeEnum["SQI"] = "SQI";
    LanguageIsoCodeEnum["SRD"] = "SRD";
    LanguageIsoCodeEnum["SRP"] = "SRP";
    LanguageIsoCodeEnum["SSW"] = "SSW";
    LanguageIsoCodeEnum["SUN"] = "SUN";
    LanguageIsoCodeEnum["SWA"] = "SWA";
    LanguageIsoCodeEnum["SWE"] = "SWE";
    LanguageIsoCodeEnum["TAH"] = "TAH";
    LanguageIsoCodeEnum["TAM"] = "TAM";
    LanguageIsoCodeEnum["TAT"] = "TAT";
    LanguageIsoCodeEnum["TEL"] = "TEL";
    LanguageIsoCodeEnum["TGK"] = "TGK";
    LanguageIsoCodeEnum["TGL"] = "TGL";
    LanguageIsoCodeEnum["THA"] = "THA";
    LanguageIsoCodeEnum["TIR"] = "TIR";
    LanguageIsoCodeEnum["TON"] = "TON";
    LanguageIsoCodeEnum["TSN"] = "TSN";
    LanguageIsoCodeEnum["TSO"] = "TSO";
    LanguageIsoCodeEnum["TUK"] = "TUK";
    LanguageIsoCodeEnum["TUR"] = "TUR";
    LanguageIsoCodeEnum["TWI"] = "TWI";
    LanguageIsoCodeEnum["UIG"] = "UIG";
    LanguageIsoCodeEnum["UKR"] = "UKR";
    LanguageIsoCodeEnum["URD"] = "URD";
    LanguageIsoCodeEnum["UZB"] = "UZB";
    LanguageIsoCodeEnum["VEN"] = "VEN";
    LanguageIsoCodeEnum["VIE"] = "VIE";
    LanguageIsoCodeEnum["VOL"] = "VOL";
    LanguageIsoCodeEnum["WLN"] = "WLN";
    LanguageIsoCodeEnum["WOL"] = "WOL";
    LanguageIsoCodeEnum["XHO"] = "XHO";
    LanguageIsoCodeEnum["YID"] = "YID";
    LanguageIsoCodeEnum["YOR"] = "YOR";
    LanguageIsoCodeEnum["ZHA"] = "ZHA";
    LanguageIsoCodeEnum["ZHO"] = "ZHO";
    LanguageIsoCodeEnum["ZUL"] = "ZUL";
})(LanguageIsoCodeEnum || (LanguageIsoCodeEnum = {}));
export var CountryIsoCodeEnum;
(function (CountryIsoCodeEnum) {
    CountryIsoCodeEnum["AD"] = "AD";
    CountryIsoCodeEnum["AE"] = "AE";
    CountryIsoCodeEnum["AF"] = "AF";
    CountryIsoCodeEnum["AG"] = "AG";
    CountryIsoCodeEnum["AL"] = "AL";
    CountryIsoCodeEnum["AM"] = "AM";
    CountryIsoCodeEnum["AO"] = "AO";
    CountryIsoCodeEnum["AR"] = "AR";
    CountryIsoCodeEnum["AT"] = "AT";
    CountryIsoCodeEnum["AU"] = "AU";
    CountryIsoCodeEnum["AZ"] = "AZ";
    CountryIsoCodeEnum["BA"] = "BA";
    CountryIsoCodeEnum["BB"] = "BB";
    CountryIsoCodeEnum["BD"] = "BD";
    CountryIsoCodeEnum["BE"] = "BE";
    CountryIsoCodeEnum["BF"] = "BF";
    CountryIsoCodeEnum["BG"] = "BG";
    CountryIsoCodeEnum["BH"] = "BH";
    CountryIsoCodeEnum["BI"] = "BI";
    CountryIsoCodeEnum["BJ"] = "BJ";
    CountryIsoCodeEnum["BN"] = "BN";
    CountryIsoCodeEnum["BO"] = "BO";
    CountryIsoCodeEnum["BR"] = "BR";
    CountryIsoCodeEnum["BS"] = "BS";
    CountryIsoCodeEnum["BT"] = "BT";
    CountryIsoCodeEnum["BW"] = "BW";
    CountryIsoCodeEnum["BY"] = "BY";
    CountryIsoCodeEnum["BZ"] = "BZ";
    CountryIsoCodeEnum["CA"] = "CA";
    CountryIsoCodeEnum["CD"] = "CD";
    CountryIsoCodeEnum["CF"] = "CF";
    CountryIsoCodeEnum["CG"] = "CG";
    CountryIsoCodeEnum["CH"] = "CH";
    CountryIsoCodeEnum["CI"] = "CI";
    CountryIsoCodeEnum["CL"] = "CL";
    CountryIsoCodeEnum["CM"] = "CM";
    CountryIsoCodeEnum["CN"] = "CN";
    CountryIsoCodeEnum["CO"] = "CO";
    CountryIsoCodeEnum["CR"] = "CR";
    CountryIsoCodeEnum["CU"] = "CU";
    CountryIsoCodeEnum["CV"] = "CV";
    CountryIsoCodeEnum["CY"] = "CY";
    CountryIsoCodeEnum["CZ"] = "CZ";
    CountryIsoCodeEnum["DE"] = "DE";
    CountryIsoCodeEnum["DJ"] = "DJ";
    CountryIsoCodeEnum["DK"] = "DK";
    CountryIsoCodeEnum["DM"] = "DM";
    CountryIsoCodeEnum["DO"] = "DO";
    CountryIsoCodeEnum["DZ"] = "DZ";
    CountryIsoCodeEnum["EC"] = "EC";
    CountryIsoCodeEnum["EE"] = "EE";
    CountryIsoCodeEnum["EG"] = "EG";
    CountryIsoCodeEnum["ER"] = "ER";
    CountryIsoCodeEnum["ES"] = "ES";
    CountryIsoCodeEnum["ET"] = "ET";
    CountryIsoCodeEnum["FI"] = "FI";
    CountryIsoCodeEnum["FJ"] = "FJ";
    CountryIsoCodeEnum["FM"] = "FM";
    CountryIsoCodeEnum["FR"] = "FR";
    CountryIsoCodeEnum["GA"] = "GA";
    CountryIsoCodeEnum["GB"] = "GB";
    CountryIsoCodeEnum["GD"] = "GD";
    CountryIsoCodeEnum["GE"] = "GE";
    CountryIsoCodeEnum["GH"] = "GH";
    CountryIsoCodeEnum["GM"] = "GM";
    CountryIsoCodeEnum["GN"] = "GN";
    CountryIsoCodeEnum["GQ"] = "GQ";
    CountryIsoCodeEnum["GR"] = "GR";
    CountryIsoCodeEnum["GT"] = "GT";
    CountryIsoCodeEnum["GW"] = "GW";
    CountryIsoCodeEnum["GY"] = "GY";
    CountryIsoCodeEnum["HN"] = "HN";
    CountryIsoCodeEnum["HR"] = "HR";
    CountryIsoCodeEnum["HT"] = "HT";
    CountryIsoCodeEnum["HU"] = "HU";
    CountryIsoCodeEnum["ID"] = "ID";
    CountryIsoCodeEnum["IE"] = "IE";
    CountryIsoCodeEnum["IL"] = "IL";
    CountryIsoCodeEnum["IN"] = "IN";
    CountryIsoCodeEnum["IQ"] = "IQ";
    CountryIsoCodeEnum["IR"] = "IR";
    CountryIsoCodeEnum["IS"] = "IS";
    CountryIsoCodeEnum["IT"] = "IT";
    CountryIsoCodeEnum["JM"] = "JM";
    CountryIsoCodeEnum["JO"] = "JO";
    CountryIsoCodeEnum["JP"] = "JP";
    CountryIsoCodeEnum["KE"] = "KE";
    CountryIsoCodeEnum["KG"] = "KG";
    CountryIsoCodeEnum["KH"] = "KH";
    CountryIsoCodeEnum["KI"] = "KI";
    CountryIsoCodeEnum["KM"] = "KM";
    CountryIsoCodeEnum["KN"] = "KN";
    CountryIsoCodeEnum["KP"] = "KP";
    CountryIsoCodeEnum["KR"] = "KR";
    CountryIsoCodeEnum["KW"] = "KW";
    CountryIsoCodeEnum["KZ"] = "KZ";
    CountryIsoCodeEnum["LA"] = "LA";
    CountryIsoCodeEnum["LB"] = "LB";
    CountryIsoCodeEnum["LC"] = "LC";
    CountryIsoCodeEnum["LI"] = "LI";
    CountryIsoCodeEnum["LK"] = "LK";
    CountryIsoCodeEnum["LR"] = "LR";
    CountryIsoCodeEnum["LS"] = "LS";
    CountryIsoCodeEnum["LT"] = "LT";
    CountryIsoCodeEnum["LU"] = "LU";
    CountryIsoCodeEnum["LV"] = "LV";
    CountryIsoCodeEnum["LY"] = "LY";
    CountryIsoCodeEnum["MA"] = "MA";
    CountryIsoCodeEnum["MC"] = "MC";
    CountryIsoCodeEnum["MD"] = "MD";
    CountryIsoCodeEnum["ME"] = "ME";
    CountryIsoCodeEnum["MG"] = "MG";
    CountryIsoCodeEnum["MH"] = "MH";
    CountryIsoCodeEnum["MK"] = "MK";
    CountryIsoCodeEnum["ML"] = "ML";
    CountryIsoCodeEnum["MM"] = "MM";
    CountryIsoCodeEnum["MN"] = "MN";
    CountryIsoCodeEnum["MR"] = "MR";
    CountryIsoCodeEnum["MT"] = "MT";
    CountryIsoCodeEnum["MU"] = "MU";
    CountryIsoCodeEnum["MV"] = "MV";
    CountryIsoCodeEnum["MW"] = "MW";
    CountryIsoCodeEnum["MX"] = "MX";
    CountryIsoCodeEnum["MY"] = "MY";
    CountryIsoCodeEnum["MZ"] = "MZ";
    CountryIsoCodeEnum["NA"] = "NA";
    CountryIsoCodeEnum["NE"] = "NE";
    CountryIsoCodeEnum["NG"] = "NG";
    CountryIsoCodeEnum["NI"] = "NI";
    CountryIsoCodeEnum["NL"] = "NL";
    CountryIsoCodeEnum["NO"] = "NO";
    CountryIsoCodeEnum["NP"] = "NP";
    CountryIsoCodeEnum["NR"] = "NR";
    CountryIsoCodeEnum["NZ"] = "NZ";
    CountryIsoCodeEnum["OM"] = "OM";
    CountryIsoCodeEnum["PA"] = "PA";
    CountryIsoCodeEnum["PE"] = "PE";
    CountryIsoCodeEnum["PG"] = "PG";
    CountryIsoCodeEnum["PH"] = "PH";
    CountryIsoCodeEnum["PK"] = "PK";
    CountryIsoCodeEnum["PL"] = "PL";
    CountryIsoCodeEnum["PT"] = "PT";
    CountryIsoCodeEnum["PW"] = "PW";
    CountryIsoCodeEnum["PY"] = "PY";
    CountryIsoCodeEnum["QA"] = "QA";
    CountryIsoCodeEnum["RO"] = "RO";
    CountryIsoCodeEnum["RS"] = "RS";
    CountryIsoCodeEnum["RU"] = "RU";
    CountryIsoCodeEnum["RW"] = "RW";
    CountryIsoCodeEnum["SA"] = "SA";
    CountryIsoCodeEnum["SB"] = "SB";
    CountryIsoCodeEnum["SC"] = "SC";
    CountryIsoCodeEnum["SD"] = "SD";
    CountryIsoCodeEnum["SE"] = "SE";
    CountryIsoCodeEnum["SG"] = "SG";
    CountryIsoCodeEnum["SI"] = "SI";
    CountryIsoCodeEnum["SK"] = "SK";
    CountryIsoCodeEnum["SL"] = "SL";
    CountryIsoCodeEnum["SM"] = "SM";
    CountryIsoCodeEnum["SN"] = "SN";
    CountryIsoCodeEnum["SO"] = "SO";
    CountryIsoCodeEnum["SR"] = "SR";
    CountryIsoCodeEnum["SS"] = "SS";
    CountryIsoCodeEnum["ST"] = "ST";
    CountryIsoCodeEnum["SV"] = "SV";
    CountryIsoCodeEnum["SY"] = "SY";
    CountryIsoCodeEnum["SZ"] = "SZ";
    CountryIsoCodeEnum["TD"] = "TD";
    CountryIsoCodeEnum["TG"] = "TG";
    CountryIsoCodeEnum["TH"] = "TH";
    CountryIsoCodeEnum["TJ"] = "TJ";
    CountryIsoCodeEnum["TL"] = "TL";
    CountryIsoCodeEnum["TM"] = "TM";
    CountryIsoCodeEnum["TN"] = "TN";
    CountryIsoCodeEnum["TO"] = "TO";
    CountryIsoCodeEnum["TR"] = "TR";
    CountryIsoCodeEnum["TT"] = "TT";
    CountryIsoCodeEnum["TV"] = "TV";
    CountryIsoCodeEnum["TW"] = "TW";
    CountryIsoCodeEnum["TZ"] = "TZ";
    CountryIsoCodeEnum["UA"] = "UA";
    CountryIsoCodeEnum["UG"] = "UG";
    CountryIsoCodeEnum["US"] = "US";
    CountryIsoCodeEnum["UY"] = "UY";
    CountryIsoCodeEnum["UZ"] = "UZ";
    CountryIsoCodeEnum["VA"] = "VA";
    CountryIsoCodeEnum["VC"] = "VC";
    CountryIsoCodeEnum["VE"] = "VE";
    CountryIsoCodeEnum["VN"] = "VN";
    CountryIsoCodeEnum["VU"] = "VU";
    CountryIsoCodeEnum["WS"] = "WS";
    CountryIsoCodeEnum["XA"] = "XA";
    CountryIsoCodeEnum["XK"] = "XK";
    CountryIsoCodeEnum["XX"] = "XX";
    CountryIsoCodeEnum["XZ"] = "XZ";
    CountryIsoCodeEnum["YE"] = "YE";
    CountryIsoCodeEnum["ZA"] = "ZA";
    CountryIsoCodeEnum["ZM"] = "ZM";
    CountryIsoCodeEnum["ZW"] = "ZW";
})(CountryIsoCodeEnum || (CountryIsoCodeEnum = {}));
export var CountryCallingCodeEnum;
(function (CountryCallingCodeEnum) {
    CountryCallingCodeEnum["C999"] = "+999";
    CountryCallingCodeEnum["C998"] = "+998";
    CountryCallingCodeEnum["C997"] = "+997";
    CountryCallingCodeEnum["C996"] = "+996";
    CountryCallingCodeEnum["C995"] = "+995";
    CountryCallingCodeEnum["C994"] = "+994";
    CountryCallingCodeEnum["C993"] = "+993";
    CountryCallingCodeEnum["C992"] = "+992";
    CountryCallingCodeEnum["C991"] = "+991";
    CountryCallingCodeEnum["C990"] = "+990";
    CountryCallingCodeEnum["C98"] = "+98";
    CountryCallingCodeEnum["C979"] = "+979";
    CountryCallingCodeEnum["C978"] = "+978";
    CountryCallingCodeEnum["C977"] = "+977";
    CountryCallingCodeEnum["C976"] = "+976";
    CountryCallingCodeEnum["C975"] = "+975";
    CountryCallingCodeEnum["C974"] = "+974";
    CountryCallingCodeEnum["C973"] = "+973";
    CountryCallingCodeEnum["C972"] = "+972";
    CountryCallingCodeEnum["C971"] = "+971";
    CountryCallingCodeEnum["C970"] = "+970";
    CountryCallingCodeEnum["C969"] = "+969";
    CountryCallingCodeEnum["C968"] = "+968";
    CountryCallingCodeEnum["C967"] = "+967";
    CountryCallingCodeEnum["C966"] = "+966";
    CountryCallingCodeEnum["C965"] = "+965";
    CountryCallingCodeEnum["C964"] = "+964";
    CountryCallingCodeEnum["C963"] = "+963";
    CountryCallingCodeEnum["C962"] = "+962";
    CountryCallingCodeEnum["C961"] = "+961";
    CountryCallingCodeEnum["C960"] = "+960";
    CountryCallingCodeEnum["C95"] = "+95";
    CountryCallingCodeEnum["C94"] = "+94";
    CountryCallingCodeEnum["C93"] = "+93";
    CountryCallingCodeEnum["C92"] = "+92";
    CountryCallingCodeEnum["C91"] = "+91";
    CountryCallingCodeEnum["C90"] = "+90";
    CountryCallingCodeEnum["C899"] = "+899";
    CountryCallingCodeEnum["C898"] = "+898";
    CountryCallingCodeEnum["C897"] = "+897";
    CountryCallingCodeEnum["C896"] = "+896";
    CountryCallingCodeEnum["C895"] = "+895";
    CountryCallingCodeEnum["C894"] = "+894";
    CountryCallingCodeEnum["C893"] = "+893";
    CountryCallingCodeEnum["C892"] = "+892";
    CountryCallingCodeEnum["C891"] = "+891";
    CountryCallingCodeEnum["C890"] = "+890";
    CountryCallingCodeEnum["C889"] = "+889";
    CountryCallingCodeEnum["C888"] = "+888";
    CountryCallingCodeEnum["C887"] = "+887";
    CountryCallingCodeEnum["C886"] = "+886";
    CountryCallingCodeEnum["C885"] = "+885";
    CountryCallingCodeEnum["C884"] = "+884";
    CountryCallingCodeEnum["C8835160"] = "+8835160";
    CountryCallingCodeEnum["C8835150"] = "+8835150";
    CountryCallingCodeEnum["C8835140"] = "+8835140";
    CountryCallingCodeEnum["C8835130"] = "+8835130";
    CountryCallingCodeEnum["C8835120"] = "+8835120";
    CountryCallingCodeEnum["C8835110"] = "+8835110";
    CountryCallingCodeEnum["C8835100"] = "+8835100";
    CountryCallingCodeEnum["C883200"] = "+883200";
    CountryCallingCodeEnum["C883190"] = "+883190";
    CountryCallingCodeEnum["C883180"] = "+883180";
    CountryCallingCodeEnum["C883170"] = "+883170";
    CountryCallingCodeEnum["C883160"] = "+883160";
    CountryCallingCodeEnum["C883150"] = "+883150";
    CountryCallingCodeEnum["C883140"] = "+883140";
    CountryCallingCodeEnum["C883130"] = "+883130";
    CountryCallingCodeEnum["C883120"] = "+883120";
    CountryCallingCodeEnum["C883110"] = "+883110";
    CountryCallingCodeEnum["C883100"] = "+883100";
    CountryCallingCodeEnum["C883"] = "+883";
    CountryCallingCodeEnum["C88299"] = "+88299";
    CountryCallingCodeEnum["C88298"] = "+88298";
    CountryCallingCodeEnum["C88297"] = "+88297";
    CountryCallingCodeEnum["C88248"] = "+88248";
    CountryCallingCodeEnum["C88247"] = "+88247";
    CountryCallingCodeEnum["C88246"] = "+88246";
    CountryCallingCodeEnum["C88245"] = "+88245";
    CountryCallingCodeEnum["C88241"] = "+88241";
    CountryCallingCodeEnum["C88239"] = "+88239";
    CountryCallingCodeEnum["C88237"] = "+88237";
    CountryCallingCodeEnum["C88236"] = "+88236";
    CountryCallingCodeEnum["C88235"] = "+88235";
    CountryCallingCodeEnum["C88234"] = "+88234";
    CountryCallingCodeEnum["C88233"] = "+88233";
    CountryCallingCodeEnum["C88232"] = "+88232";
    CountryCallingCodeEnum["C88231"] = "+88231";
    CountryCallingCodeEnum["C88228"] = "+88228";
    CountryCallingCodeEnum["C88223"] = "+88223";
    CountryCallingCodeEnum["C88222"] = "+88222";
    CountryCallingCodeEnum["C88216"] = "+88216";
    CountryCallingCodeEnum["C88215"] = "+88215";
    CountryCallingCodeEnum["C88213"] = "+88213";
    CountryCallingCodeEnum["C88212"] = "+88212";
    CountryCallingCodeEnum["C88210"] = "+88210";
    CountryCallingCodeEnum["C882"] = "+882";
    CountryCallingCodeEnum["C8819"] = "+8819";
    CountryCallingCodeEnum["C8818"] = "+8818";
    CountryCallingCodeEnum["C8817"] = "+8817";
    CountryCallingCodeEnum["C8816"] = "+8816";
    CountryCallingCodeEnum["C881"] = "+881";
    CountryCallingCodeEnum["C880"] = "+880";
    CountryCallingCodeEnum["C879"] = "+879";
    CountryCallingCodeEnum["C878"] = "+878";
    CountryCallingCodeEnum["C877"] = "+877";
    CountryCallingCodeEnum["C876"] = "+876";
    CountryCallingCodeEnum["C875"] = "+875";
    CountryCallingCodeEnum["C874"] = "+874";
    CountryCallingCodeEnum["C873"] = "+873";
    CountryCallingCodeEnum["C872"] = "+872";
    CountryCallingCodeEnum["C871"] = "+871";
    CountryCallingCodeEnum["C870"] = "+870";
    CountryCallingCodeEnum["C86"] = "+86";
    CountryCallingCodeEnum["C859"] = "+859";
    CountryCallingCodeEnum["C858"] = "+858";
    CountryCallingCodeEnum["C857"] = "+857";
    CountryCallingCodeEnum["C856"] = "+856";
    CountryCallingCodeEnum["C855"] = "+855";
    CountryCallingCodeEnum["C854"] = "+854";
    CountryCallingCodeEnum["C853"] = "+853";
    CountryCallingCodeEnum["C852"] = "+852";
    CountryCallingCodeEnum["C851"] = "+851";
    CountryCallingCodeEnum["C850"] = "+850";
    CountryCallingCodeEnum["C84"] = "+84";
    CountryCallingCodeEnum["C839"] = "+839";
    CountryCallingCodeEnum["C838"] = "+838";
    CountryCallingCodeEnum["C837"] = "+837";
    CountryCallingCodeEnum["C836"] = "+836";
    CountryCallingCodeEnum["C835"] = "+835";
    CountryCallingCodeEnum["C834"] = "+834";
    CountryCallingCodeEnum["C833"] = "+833";
    CountryCallingCodeEnum["C832"] = "+832";
    CountryCallingCodeEnum["C831"] = "+831";
    CountryCallingCodeEnum["C830"] = "+830";
    CountryCallingCodeEnum["C82"] = "+82";
    CountryCallingCodeEnum["C81"] = "+81";
    CountryCallingCodeEnum["C809"] = "+809";
    CountryCallingCodeEnum["C808"] = "+808";
    CountryCallingCodeEnum["C807"] = "+807";
    CountryCallingCodeEnum["C806"] = "+806";
    CountryCallingCodeEnum["C805"] = "+805";
    CountryCallingCodeEnum["C804"] = "+804";
    CountryCallingCodeEnum["C803"] = "+803";
    CountryCallingCodeEnum["C802"] = "+802";
    CountryCallingCodeEnum["C801"] = "+801";
    CountryCallingCodeEnum["C800"] = "+800";
    CountryCallingCodeEnum["C77"] = "+77";
    CountryCallingCodeEnum["C76"] = "+76";
    CountryCallingCodeEnum["C7"] = "+7";
    CountryCallingCodeEnum["C699"] = "+699";
    CountryCallingCodeEnum["C698"] = "+698";
    CountryCallingCodeEnum["C697"] = "+697";
    CountryCallingCodeEnum["C696"] = "+696";
    CountryCallingCodeEnum["C695"] = "+695";
    CountryCallingCodeEnum["C694"] = "+694";
    CountryCallingCodeEnum["C693"] = "+693";
    CountryCallingCodeEnum["C692"] = "+692";
    CountryCallingCodeEnum["C691"] = "+691";
    CountryCallingCodeEnum["C690"] = "+690";
    CountryCallingCodeEnum["C689"] = "+689";
    CountryCallingCodeEnum["C688"] = "+688";
    CountryCallingCodeEnum["C687"] = "+687";
    CountryCallingCodeEnum["C686"] = "+686";
    CountryCallingCodeEnum["C685"] = "+685";
    CountryCallingCodeEnum["C684"] = "+684";
    CountryCallingCodeEnum["C683"] = "+683";
    CountryCallingCodeEnum["C682"] = "+682";
    CountryCallingCodeEnum["C681"] = "+681";
    CountryCallingCodeEnum["C680"] = "+680";
    CountryCallingCodeEnum["C679"] = "+679";
    CountryCallingCodeEnum["C678"] = "+678";
    CountryCallingCodeEnum["C677"] = "+677";
    CountryCallingCodeEnum["C676"] = "+676";
    CountryCallingCodeEnum["C675"] = "+675";
    CountryCallingCodeEnum["C674"] = "+674";
    CountryCallingCodeEnum["C673"] = "+673";
    CountryCallingCodeEnum["C672"] = "+672";
    CountryCallingCodeEnum["C671"] = "+671";
    CountryCallingCodeEnum["C670"] = "+670";
    CountryCallingCodeEnum["C66"] = "+66";
    CountryCallingCodeEnum["C65"] = "+65";
    CountryCallingCodeEnum["C64"] = "+64";
    CountryCallingCodeEnum["C63"] = "+63";
    CountryCallingCodeEnum["C62"] = "+62";
    CountryCallingCodeEnum["C61"] = "+61";
    CountryCallingCodeEnum["C60"] = "+60";
    CountryCallingCodeEnum["C5999"] = "+5999";
    CountryCallingCodeEnum["C599"] = "+599";
    CountryCallingCodeEnum["C598"] = "+598";
    CountryCallingCodeEnum["C597"] = "+597";
    CountryCallingCodeEnum["C596"] = "+596";
    CountryCallingCodeEnum["C595"] = "+595";
    CountryCallingCodeEnum["C594"] = "+594";
    CountryCallingCodeEnum["C593"] = "+593";
    CountryCallingCodeEnum["C592"] = "+592";
    CountryCallingCodeEnum["C591"] = "+591";
    CountryCallingCodeEnum["C590"] = "+590";
    CountryCallingCodeEnum["C58"] = "+58";
    CountryCallingCodeEnum["C57"] = "+57";
    CountryCallingCodeEnum["C56"] = "+56";
    CountryCallingCodeEnum["C55"] = "+55";
    CountryCallingCodeEnum["C54"] = "+54";
    CountryCallingCodeEnum["C53"] = "+53";
    CountryCallingCodeEnum["C52"] = "+52";
    CountryCallingCodeEnum["C51"] = "+51";
    CountryCallingCodeEnum["C509"] = "+509";
    CountryCallingCodeEnum["C508"] = "+508";
    CountryCallingCodeEnum["C507"] = "+507";
    CountryCallingCodeEnum["C506"] = "+506";
    CountryCallingCodeEnum["C505"] = "+505";
    CountryCallingCodeEnum["C504"] = "+504";
    CountryCallingCodeEnum["C503"] = "+503";
    CountryCallingCodeEnum["C502"] = "+502";
    CountryCallingCodeEnum["C501"] = "+501";
    CountryCallingCodeEnum["C500"] = "+500";
    CountryCallingCodeEnum["C49"] = "+49";
    CountryCallingCodeEnum["C48"] = "+48";
    CountryCallingCodeEnum["C47"] = "+47";
    CountryCallingCodeEnum["C46"] = "+46";
    CountryCallingCodeEnum["C45"] = "+45";
    CountryCallingCodeEnum["C44"] = "+44";
    CountryCallingCodeEnum["C43"] = "+43";
    CountryCallingCodeEnum["C429"] = "+429";
    CountryCallingCodeEnum["C428"] = "+428";
    CountryCallingCodeEnum["C427"] = "+427";
    CountryCallingCodeEnum["C426"] = "+426";
    CountryCallingCodeEnum["C425"] = "+425";
    CountryCallingCodeEnum["C424"] = "+424";
    CountryCallingCodeEnum["C423"] = "+423";
    CountryCallingCodeEnum["C422"] = "+422";
    CountryCallingCodeEnum["C421"] = "+421";
    CountryCallingCodeEnum["C420"] = "+420";
    CountryCallingCodeEnum["C41"] = "+41";
    CountryCallingCodeEnum["C40"] = "+40";
    CountryCallingCodeEnum["C3906698"] = "+3906698";
    CountryCallingCodeEnum["C39"] = "+39";
    CountryCallingCodeEnum["C389"] = "+389";
    CountryCallingCodeEnum["C388"] = "+388";
    CountryCallingCodeEnum["C387"] = "+387";
    CountryCallingCodeEnum["C386"] = "+386";
    CountryCallingCodeEnum["C385"] = "+385";
    CountryCallingCodeEnum["C384"] = "+384";
    CountryCallingCodeEnum["C383"] = "+383";
    CountryCallingCodeEnum["C382"] = "+382";
    CountryCallingCodeEnum["C381"] = "+381";
    CountryCallingCodeEnum["C380"] = "+380";
    CountryCallingCodeEnum["C379"] = "+379";
    CountryCallingCodeEnum["C378"] = "+378";
    CountryCallingCodeEnum["C377"] = "+377";
    CountryCallingCodeEnum["C376"] = "+376";
    CountryCallingCodeEnum["C375"] = "+375";
    CountryCallingCodeEnum["C374"] = "+374";
    CountryCallingCodeEnum["C373"] = "+373";
    CountryCallingCodeEnum["C372"] = "+372";
    CountryCallingCodeEnum["C371"] = "+371";
    CountryCallingCodeEnum["C370"] = "+370";
    CountryCallingCodeEnum["C36"] = "+36";
    CountryCallingCodeEnum["C359"] = "+359";
    CountryCallingCodeEnum["C358"] = "+358";
    CountryCallingCodeEnum["C357"] = "+357";
    CountryCallingCodeEnum["C356"] = "+356";
    CountryCallingCodeEnum["C355"] = "+355";
    CountryCallingCodeEnum["C354"] = "+354";
    CountryCallingCodeEnum["C353"] = "+353";
    CountryCallingCodeEnum["C352"] = "+352";
    CountryCallingCodeEnum["C351"] = "+351";
    CountryCallingCodeEnum["C350"] = "+350";
    CountryCallingCodeEnum["C34"] = "+34";
    CountryCallingCodeEnum["C33"] = "+33";
    CountryCallingCodeEnum["C32"] = "+32";
    CountryCallingCodeEnum["C31"] = "+31";
    CountryCallingCodeEnum["C30"] = "+30";
    CountryCallingCodeEnum["C299"] = "+299";
    CountryCallingCodeEnum["C298"] = "+298";
    CountryCallingCodeEnum["C297"] = "+297";
    CountryCallingCodeEnum["C296"] = "+296";
    CountryCallingCodeEnum["C295"] = "+295";
    CountryCallingCodeEnum["C294"] = "+294";
    CountryCallingCodeEnum["C293"] = "+293";
    CountryCallingCodeEnum["C292"] = "+292";
    CountryCallingCodeEnum["C291"] = "+291";
    CountryCallingCodeEnum["C290"] = "+290";
    CountryCallingCodeEnum["C289"] = "+289";
    CountryCallingCodeEnum["C288"] = "+288";
    CountryCallingCodeEnum["C287"] = "+287";
    CountryCallingCodeEnum["C286"] = "+286";
    CountryCallingCodeEnum["C285"] = "+285";
    CountryCallingCodeEnum["C284"] = "+284";
    CountryCallingCodeEnum["C283"] = "+283";
    CountryCallingCodeEnum["C282"] = "+282";
    CountryCallingCodeEnum["C281"] = "+281";
    CountryCallingCodeEnum["C280"] = "+280";
    CountryCallingCodeEnum["C27"] = "+27";
    CountryCallingCodeEnum["C269"] = "+269";
    CountryCallingCodeEnum["C268"] = "+268";
    CountryCallingCodeEnum["C267"] = "+267";
    CountryCallingCodeEnum["C266"] = "+266";
    CountryCallingCodeEnum["C265"] = "+265";
    CountryCallingCodeEnum["C264"] = "+264";
    CountryCallingCodeEnum["C263"] = "+263";
    CountryCallingCodeEnum["C262"] = "+262";
    CountryCallingCodeEnum["C261"] = "+261";
    CountryCallingCodeEnum["C260"] = "+260";
    CountryCallingCodeEnum["C259"] = "+259";
    CountryCallingCodeEnum["C258"] = "+258";
    CountryCallingCodeEnum["C257"] = "+257";
    CountryCallingCodeEnum["C256"] = "+256";
    CountryCallingCodeEnum["C255"] = "+255";
    CountryCallingCodeEnum["C254"] = "+254";
    CountryCallingCodeEnum["C253"] = "+253";
    CountryCallingCodeEnum["C252"] = "+252";
    CountryCallingCodeEnum["C251"] = "+251";
    CountryCallingCodeEnum["C250"] = "+250";
    CountryCallingCodeEnum["C249"] = "+249";
    CountryCallingCodeEnum["C248"] = "+248";
    CountryCallingCodeEnum["C247"] = "+247";
    CountryCallingCodeEnum["C246"] = "+246";
    CountryCallingCodeEnum["C245"] = "+245";
    CountryCallingCodeEnum["C244"] = "+244";
    CountryCallingCodeEnum["C243"] = "+243";
    CountryCallingCodeEnum["C242"] = "+242";
    CountryCallingCodeEnum["C241"] = "+241";
    CountryCallingCodeEnum["C240"] = "+240";
    CountryCallingCodeEnum["C239"] = "+239";
    CountryCallingCodeEnum["C238"] = "+238";
    CountryCallingCodeEnum["C237"] = "+237";
    CountryCallingCodeEnum["C236"] = "+236";
    CountryCallingCodeEnum["C235"] = "+235";
    CountryCallingCodeEnum["C234"] = "+234";
    CountryCallingCodeEnum["C233"] = "+233";
    CountryCallingCodeEnum["C232"] = "+232";
    CountryCallingCodeEnum["C231"] = "+231";
    CountryCallingCodeEnum["C230"] = "+230";
    CountryCallingCodeEnum["C229"] = "+229";
    CountryCallingCodeEnum["C228"] = "+228";
    CountryCallingCodeEnum["C227"] = "+227";
    CountryCallingCodeEnum["C226"] = "+226";
    CountryCallingCodeEnum["C225"] = "+225";
    CountryCallingCodeEnum["C224"] = "+224";
    CountryCallingCodeEnum["C223"] = "+223";
    CountryCallingCodeEnum["C222"] = "+222";
    CountryCallingCodeEnum["C221"] = "+221";
    CountryCallingCodeEnum["C220"] = "+220";
    CountryCallingCodeEnum["C219"] = "+219";
    CountryCallingCodeEnum["C218"] = "+218";
    CountryCallingCodeEnum["C217"] = "+217";
    CountryCallingCodeEnum["C216"] = "+216";
    CountryCallingCodeEnum["C215"] = "+215";
    CountryCallingCodeEnum["C214"] = "+214";
    CountryCallingCodeEnum["C213"] = "+213";
    CountryCallingCodeEnum["C212"] = "+212";
    CountryCallingCodeEnum["C211"] = "+211";
    CountryCallingCodeEnum["C210"] = "+210";
    CountryCallingCodeEnum["C20"] = "+20";
    CountryCallingCodeEnum["C1939"] = "+1939";
    CountryCallingCodeEnum["C1876"] = "+1876";
    CountryCallingCodeEnum["C1869"] = "+1869";
    CountryCallingCodeEnum["C1868"] = "+1868";
    CountryCallingCodeEnum["C1849"] = "+1849";
    CountryCallingCodeEnum["C1829"] = "+1829";
    CountryCallingCodeEnum["C1809"] = "+1809";
    CountryCallingCodeEnum["C1787"] = "+1787";
    CountryCallingCodeEnum["C1784"] = "+1784";
    CountryCallingCodeEnum["C1767"] = "+1767";
    CountryCallingCodeEnum["C1758"] = "+1758";
    CountryCallingCodeEnum["C1721"] = "+1721";
    CountryCallingCodeEnum["C1684"] = "+1684";
    CountryCallingCodeEnum["C1671"] = "+1671";
    CountryCallingCodeEnum["C1670"] = "+1670";
    CountryCallingCodeEnum["C1664"] = "+1664";
    CountryCallingCodeEnum["C1658"] = "+1658";
    CountryCallingCodeEnum["C1649"] = "+1649";
    CountryCallingCodeEnum["C1473"] = "+1473";
    CountryCallingCodeEnum["C1441"] = "+1441";
    CountryCallingCodeEnum["C1345"] = "+1345";
    CountryCallingCodeEnum["C1340"] = "+1340";
    CountryCallingCodeEnum["C1284"] = "+1284";
    CountryCallingCodeEnum["C1268"] = "+1268";
    CountryCallingCodeEnum["C1264"] = "+1264";
    CountryCallingCodeEnum["C1246"] = "+1246";
    CountryCallingCodeEnum["C1242"] = "+1242";
    CountryCallingCodeEnum["C1"] = "+1";
    CountryCallingCodeEnum["C0"] = "+0";
})(CountryCallingCodeEnum || (CountryCallingCodeEnum = {}));
export var CountryAreaCodeEnum;
(function (CountryAreaCodeEnum) {
    CountryAreaCodeEnum["A650"] = "650";
    CountryAreaCodeEnum["A651"] = "651";
    CountryAreaCodeEnum["A652"] = "652";
    CountryAreaCodeEnum["A653"] = "653";
    CountryAreaCodeEnum["A655"] = "655";
    CountryAreaCodeEnum["A657"] = "657";
    CountryAreaCodeEnum["A659"] = "659";
    CountryAreaCodeEnum["A660"] = "660";
    CountryAreaCodeEnum["A661"] = "661";
    CountryAreaCodeEnum["A663"] = "663";
    CountryAreaCodeEnum["A664"] = "664";
    CountryAreaCodeEnum["A665"] = "665";
    CountryAreaCodeEnum["A666"] = "666";
    CountryAreaCodeEnum["A667"] = "667";
    CountryAreaCodeEnum["A668"] = "668";
    CountryAreaCodeEnum["A669"] = "669";
    CountryAreaCodeEnum["A670"] = "670";
    CountryAreaCodeEnum["A671"] = "671";
    CountryAreaCodeEnum["A672"] = "672";
    CountryAreaCodeEnum["A673"] = "673";
    CountryAreaCodeEnum["A674"] = "674";
    CountryAreaCodeEnum["A675"] = "675";
    CountryAreaCodeEnum["A676"] = "676";
    CountryAreaCodeEnum["A677"] = "677";
    CountryAreaCodeEnum["A678"] = "678";
    CountryAreaCodeEnum["A679"] = "679";
    CountryAreaCodeEnum["A680"] = "680";
    CountryAreaCodeEnum["A681"] = "681";
    CountryAreaCodeEnum["A682"] = "682";
    CountryAreaCodeEnum["A683"] = "683";
    CountryAreaCodeEnum["A684"] = "684";
    CountryAreaCodeEnum["A685"] = "685";
    CountryAreaCodeEnum["A686"] = "686";
    CountryAreaCodeEnum["A687"] = "687";
    CountryAreaCodeEnum["A688"] = "688";
    CountryAreaCodeEnum["A689"] = "689";
    CountryAreaCodeEnum["A690"] = "690";
    CountryAreaCodeEnum["A691"] = "691";
    CountryAreaCodeEnum["A692"] = "692";
    CountryAreaCodeEnum["A693"] = "693";
    CountryAreaCodeEnum["A694"] = "694";
    CountryAreaCodeEnum["A695"] = "695";
    CountryAreaCodeEnum["A696"] = "696";
    CountryAreaCodeEnum["A697"] = "697";
    CountryAreaCodeEnum["A698"] = "698";
    CountryAreaCodeEnum["_699"] = "699";
})(CountryAreaCodeEnum || (CountryAreaCodeEnum = {}));
export var SigningAuthorityEnum;
(function (SigningAuthorityEnum) {
    SigningAuthorityEnum["SELBSTSTAENDIG"] = "SELBSTST\u00C4NDIG";
    SigningAuthorityEnum["GEMEINSAM"] = "GEMEINSAM";
})(SigningAuthorityEnum || (SigningAuthorityEnum = {}));
export var VoucherTypeEnum;
(function (VoucherTypeEnum) {
    VoucherTypeEnum["AMZ"] = "AMZ";
    VoucherTypeEnum["ZAL"] = "ZAL";
    VoucherTypeEnum["UNB"] = "UNB";
})(VoucherTypeEnum || (VoucherTypeEnum = {}));
export var DocTypeEnum;
(function (DocTypeEnum) {
    DocTypeEnum["IDN"] = "IDN";
    DocTypeEnum["KOR"] = "KOR";
})(DocTypeEnum || (DocTypeEnum = {}));
export var DocSubTypeEnum;
(function (DocSubTypeEnum) {
    DocSubTypeEnum["FUEH"] = "FUEH";
    DocSubTypeEnum["PERS"] = "PERS";
    DocSubTypeEnum["REIS"] = "REIS";
    DocSubTypeEnum["AUFH"] = "AUFH";
    DocSubTypeEnum["KONV"] = "KONV";
    DocSubTypeEnum["LEGI"] = "LEGI";
    DocSubTypeEnum["GEBU"] = "GEBU";
    DocSubTypeEnum["HEIR"] = "HEIR";
    DocSubTypeEnum["NAAE"] = "NAAE";
    DocSubTypeEnum["SCHE"] = "SCHE";
    DocSubTypeEnum["VOLL"] = "VOLL";
})(DocSubTypeEnum || (DocSubTypeEnum = {}));
export var RegistrationStatusEnum;
(function (RegistrationStatusEnum) {
    RegistrationStatusEnum["REGISTERED"] = "REGISTERED";
    RegistrationStatusEnum["ACTIVE"] = "ACTIVE";
    RegistrationStatusEnum["SUSPENDED"] = "SUSPENDED";
    RegistrationStatusEnum["DEACTIVATED"] = "DEACTIVATED";
    RegistrationStatusEnum["TERMINATED"] = "TERMINATED";
    RegistrationStatusEnum["REVOKED"] = "REVOKED";
})(RegistrationStatusEnum || (RegistrationStatusEnum = {}));
export var DataRetentionSourceSystemEnum;
(function (DataRetentionSourceSystemEnum) {
    DataRetentionSourceSystemEnum["LEGACY_HOST"] = "LEGACY_HOST";
})(DataRetentionSourceSystemEnum || (DataRetentionSourceSystemEnum = {}));
export var DataRetentionKeyTypeEnum;
(function (DataRetentionKeyTypeEnum) {
    DataRetentionKeyTypeEnum["POLICY_NO"] = "policyNo";
    DataRetentionKeyTypeEnum["PARTY_NO"] = "partyNo";
})(DataRetentionKeyTypeEnum || (DataRetentionKeyTypeEnum = {}));
